import { ILocalizationContext } from './localizationContext';

export enum LocalizationActionsTypes {
	REFETCH_WORDINGS = 'REFETCH_WORDINGS',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_GROUP = 'SET_GROUP',
	SET_LANGUAGE = 'SET_LANGUAGE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchWordings {
	type: LocalizationActionsTypes.REFETCH_WORDINGS;
	payload: {
		needRefetchWordings: ILocalizationContext['needRefetchWordings'];
	};
}

interface ISetAllData {
	type: LocalizationActionsTypes.SET_ALL_DATA;
	payload: {
		groups: ILocalizationContext['groups'];
	};
}

interface ISetGroup {
	type: LocalizationActionsTypes.SET_GROUP;
	payload: {
		selectedGroup: ILocalizationContext['selectedGroup'];
	};
}

interface ISetLanguage {
	type: LocalizationActionsTypes.SET_LANGUAGE;
	payload: {
		selectedLanguage: ILocalizationContext['selectedLanguage'];
	};
}

interface IChangeTypeOfModalWindow {
	type: LocalizationActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ILocalizationContext['typeOfModalWindow'];
	};
}

export type TLocalizationAction = IRefetchWordings | ISetAllData | ISetGroup | ISetLanguage | IChangeTypeOfModalWindow;
